import { render, staticRenderFns } from "./MyDashboard.vue?vue&type=template&id=4a80b03c&scoped=true&"
import script from "./MyDashboard.vue?vue&type=script&lang=ts&"
export * from "./MyDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./MyDashboard.vue?vue&type=style&index=0&id=4a80b03c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a80b03c",
  null
  
)

export default component.exports